"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var CarouselControl_1 = __importDefault(require("./CarouselControl"));
var defaultProps = {
    startPosition: 'start',
};
var styles = {
    root: {
        position: 'relative',
        height: '100%',
        width: 'fit-content',
    },
    carouselContainer: {
        margin: 50,
        display: 'flex',
        width: '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '& > *': {
            flexShrink: 0,
        },
    },
};
var Carousel = function (_a) {
    var className = _a.className, children = _a.children, startPosition = _a.startPosition;
    var containerRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), hasPrev = _b[0], setHasPrev = _b[1];
    var _c = (0, react_1.useState)(true), hasNext = _c[0], setHasNext = _c[1];
    (0, react_1.useEffect)(function () { return calcScroll(0); }, []);
    (0, react_1.useEffect)(function () { return calcScroll(); }, [children]);
    (0, react_1.useEffect)(function () {
        startPosition === 'end' && scrollToEnd();
    }, [startPosition]);
    var scrollToEnd = function () {
        var current = containerRef.current;
        if (!current)
            return;
        current.scrollTo({
            top: 0,
            left: current.scrollWidth,
            behavior: 'smooth',
        });
        calcScroll(current.scrollWidth);
    };
    var calcScroll = function (scrollLeft) {
        if (!containerRef.current) {
            return;
        }
        var _a = containerRef.current, offsetWidth = _a.offsetWidth, scrollWidth = _a.scrollWidth;
        if (scrollLeft == null) {
            scrollLeft = containerRef.current.scrollLeft;
        }
        setHasPrev(scrollLeft > 0);
        setHasNext(scrollWidth - scrollLeft > offsetWidth);
    };
    var scrollCarousel = function (prev) {
        var current = containerRef.current;
        if (!current)
            return;
        var item = current.firstElementChild;
        if (!item)
            return;
        var itemsCount = current.childElementCount;
        if (itemsCount == null) {
            itemsCount = current.childNodes.length;
        }
        if (itemsCount < 2)
            return;
        var itemWidth = 2 * Math.ceil(current.scrollWidth / itemsCount) - item.offsetWidth;
        var left = current.scrollLeft;
        left -= left % itemWidth;
        if (prev) {
            left -= itemWidth;
        }
        else {
            left += itemWidth;
        }
        current.scrollTo({
            top: 0,
            left: left,
            behavior: 'smooth',
        });
        calcScroll(left);
    };
    var buttonOffset = '0px';
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ css: styles.root, onScroll: function () { return calcScroll(); } }, { children: [hasPrev && ((0, jsx_runtime_1.jsx)(CarouselControl_1.default, { type: "left", onClick: function () { return scrollCarousel(true); }, offset: buttonOffset }, void 0)), hasNext && ((0, jsx_runtime_1.jsx)(CarouselControl_1.default, { type: "right", onClick: function () { return scrollCarousel(); }, offset: buttonOffset }, void 0)), (0, jsx_runtime_1.jsx)("div", __assign({ css: styles.carouselContainer, className: className, ref: containerRef }, { children: children }), void 0)] }), void 0));
};
Carousel.defaultProps = defaultProps;
exports.default = Carousel;
//# sourceMappingURL=index.js.map